<template>
  <div>
    <h3>Attributes:</h3>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="value" label="参数" width="100"> </el-table-column>
      <el-table-column prop="describe" label="说明" width="350"> </el-table-column>
      <el-table-column prop="type" label="类型" width="200"> </el-table-column>
      <el-table-column prop="Option" label="可选值" width="300"> </el-table-column>
      <el-table-column prop="default" label="默认值" width="150"> </el-table-column>
      <el-table-column prop="required" label="必填" width="50"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          value: " title",
          describe: "标题",
          type: "String",
          Option: "-",
          default: "-",
          required: "false"
        },
        {
          value: " value1",
          describe: "第一个输入框绑定的数据",
          type: "Number",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " value2",
          describe: "第二个输入框绑定的数据",
          type: "Number",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " placeHolderText",
          describe: "无内容时的显示文字",
          type: "string",
          Option: "-",
          default: "-",
          required: "false"
        },
        {
          value: " inputSuffixs",
          describe:
            "输入框后缀，当传入字符串时，默认两个输入框的后缀都为该字符串，当需要两个输入框显示不同后缀时，请传入数组(['suffix1', 'suffix2'])",
          type: "String|Array",
          Option: "-",
          default: "-",
          required: "false"
        },
        {
          value: " themeKey",
          describe: "主题色关键字",
          type: "String",
          Option: "bigScreen/portal",
          default: "bigScreen",
          required: "false"
        }
      ]
    }
  }
}
</script>

<style>
</style>